import { CheckoutApiError } from '../../api'
import type { CheckoutFlowErrorCode } from '../CheckoutFlow.types'

export const isExpiredCheckoutError = (error: unknown): boolean => {
  if (!(error instanceof CheckoutApiError)) return false
  if (error.status === 404) return true
  const detail = error.message.trim().toLowerCase()
  return error.status === 409 && (detail.includes('scadut') || detail.includes('expired'))
}

export const classifyBootstrapError = ({
  error,
  hasExistingSession,
}: {
  error: unknown
  hasExistingSession: boolean
}): { code: CheckoutFlowErrorCode; detail: string } => {
  if (error instanceof CheckoutApiError) {
    const detail = error.message.trim()
    const normalized = detail.toLowerCase()
    const expired = error.status === 409 && (normalized.includes('scadut') || normalized.includes('expired'))
    const emptyCart = error.status === 409 && normalized.includes('carrello') && normalized.includes('vuot')
    if (expired) {
      return {
        code: 'session_expired',
        detail,
      }
    }
    if (emptyCart) {
      return {
        code: 'empty_cart',
        detail,
      }
    }

    return {
      code: hasExistingSession ? 'session_load_failed' : 'session_creation_failed',
      detail,
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return {
      code: hasExistingSession ? 'session_load_failed' : 'session_creation_failed',
      detail: error.message,
    }
  }

  return {
    code: hasExistingSession ? 'session_load_failed' : 'session_creation_failed',
    detail: '',
  }
}
